import { Outlet } from "react-router-dom";
import SupplierSidebar from "./SupplierSidebar";

const SupplierDashboardLayout = () => {
  return (
    <div className="flex h-screen w-full bg-background overflow-hidden">
      <SupplierSidebar />
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default SupplierDashboardLayout;
